{
  "de": {
    "installment": {
      "actions": {
        "bulkEdit": {
          "detail": "Details bearbeiten",
          "reminder": "Erinnerungen bearbeiten"
        },
        "closeAllRows": "Alle Zeilen schließen",
        "deleteCount": "Sie sind dabei, {count} Rate zu löschen. Sind Sie sicher? | Sie sind dabei, {count} Raten zu löschen. Sind Sie sicher?",
        "delete_installments": "Rate löschen | Raten löschen",
        "edit": "Bearbeiten",
        "newInstallment": "Neuer Zahlungsplan",
        "openAllRows": "Alle Zeilen öffnen",
        "publish": "Veröffentlichen",
        "publishCustomer": "Veröffentlichen...",
        "save": "Aktualisieren",
        "unpublish": "Veröffentlichung aufheben",
        "updateStatus": "Status aktualisieren",
        "uploadInvoice": "Rechnung hochladen"
      },
      "attributes": {
        "amount": "Betrag",
        "customer": "Kunde",
        "description": "Beschreibung",
        "due_date": "Fälligkeit",
        "group_name": "Zahlungsplan",
        "paid_at": "Bezahlt am",
        "status_deadline": "Status",
        "unit": "Einheit"
      },
      "edit_actions": {
        "edit_amount": "Beträge",
        "edit_deadline": "Fälligkeit",
        "edit_description": "Beschreibung",
        "edit_status": "Status"
      },
      "labels": {
        "cantEditFractions": "Setzen Sie den Ratenstatus auf 'Entwurf', um die Regeln zu bearbeiten.",
        "changeStatusRequested": "Status der Raten von 'Entwurf' zu 'Rechnung gestellt' ändern",
        "changeVisibility": "Sichtbarkeit ändern...",
        "change_amounts": "Beträge ändern",
        "clear_due_date": "Fälligkeit für alle ausgewählten Raten leeren",
        "clear_paid_at": "Zahlungsdatum für alle ausgewählten Raten leeren",
        "countEdit": "Rate für 1 Einheit bearbeiten | Rate für {count} Einheiten bearbeiten",
        "created_at": "Erstellt am {created_at}",
        "deleteExplanation": "Alle Raten und Rechnungen werden dauerhaft von der Plattform entfernt.",
        "deleteExplanationGroup": "Da Sie alle Raten in dieser Ratengruppe entfernen möchten, wird die Ratengruppe ebenfalls entfernt.",
        "details": "Details",
        "edit": "Raten bearbeiten",
        "editDueDate": "Fälligkeit bearbeiten",
        "editInstallmentTerm": "Rate bearbeiten",
        "excl_vat": "zzgl. MwSt.",
        "giveNewAmount": "Neuen Betrag eingeben",
        "goToUnitInstallments": "Zu den Raten der Einheit",
        "installmentNoteExplainer": "Diese Notiz ist nur für Teammitglieder sichtbar.",
        "installment_categories": "Benutzerdefinierte Kategorien",
        "invoices": "1 Rechnung | {count} Rechnungen",
        "new_installment_fraction_category": "Kategorie",
        "noDeadline": "Keine Fälligkeit",
        "notPublished": "Nicht veröffentlicht",
        "paid": "Bezahlt",
        "published": "Veröffentlicht",
        "publishedCustomer": "Für Kunden veröffentlicht",
        "publishingForCustomers": "Sind Sie sicher?",
        "selectOne": "Wählen Sie mindestens 1 Rate aus",
        "selected": "{selected} Rate ausgewählt. | {selected} Raten ausgewählt.",
        "setDueDate": "Fälligkeit festlegen",
        "statusExplained": "Was bedeutet der jeweilige Ratenstatus?",
        "status_click_to_change": "Klicken Sie, um zu ändern",
        "status_deadline": "Status",
        "statuses": {
          "draft": "Entwurf",
          "expected": "Erwartet",
          "overdue": "Überfällig",
          "paid": "Bezahlt",
          "requested": "Rechnung gestellt"
        },
        "toBePaid": "Zu zahlen",
        "total": "Gesamt",
        "unitInstallmentsWillBeShownHere": "Hier werden die Raten der Einheit angezeigt",
        "unpublishingForCustomers": "Veröffentlichung der Raten für den Kunden wird aufgehoben. Sind Sie sicher?",
        "updateStatusCount": "Status für 1 Rate aktualisieren | Status für {count} Raten aktualisieren",
        "uploadInvoiceCount": "Rechnung für 1 Rate hochladen | Rechnung für {count} Raten hochladen",
        "uploadInvoiceUnit": "Rechnung für {unit_name} hochladen",
        "vat": "MwSt.",
        "vat_with_percentage": "{percentage}% MwSt.",
        "view_list": "Liste"
      },
      "legend": {
        "installmentDraft": "Rate im Entwurf",
        "installmentDraftAfterDueDate": "Rate im Entwurf",
        "installmentExpired": "Fälligkeit abgelaufen",
        "installmentPaid": "Rate bereits bezahlt",
        "installmentPaidAfterDue": "Rate nach Fälligkeit bezahlt",
        "installmentRequested": "Rechnung gestellt",
        "reminders": {
          "active": "Mindestens 1 Erinnerung wurde festgelegt",
          "none": "Es wurden keine Erinnerungen festgelegt"
        }
      },
      "placeholders": {
        "customers": {
          "documents": {
            "subtitle": "Alle Dokumente zu den Raten werden hier angezeigt.",
            "title": "Noch keine Dokumente!"
          },
          "new": {
            "subtitle": "Neue Raten folgen in Kürze!"
          }
        }
      },
      "sort_options": {
        "due_date": "Fälligkeit",
        "due_date asc": "Früheste Fälligkeit zuerst",
        "due_date desc": "Späteste Fälligkeit zuerst",
        "group_name": "Name",
        "group_name asc": "Name A-Z",
        "group_name desc": "Name Z-A",
        "status": "Status",
        "status asc": "Status A-Z",
        "status desc": "Status Z-A",
        "updated_at asc": "Am längsten nicht aktualisiert",
        "updated_at desc": "Neueste Aktualisierung zuerst"
      },
      "validation": {
        "needNumber": "Zahl erforderlich (z. B. 8400,5)"
      }
    }
  }
}
